import { NgModule} from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CustomDropDownListComponent } from './custom-drop-down-list.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete'
import {MatSelectModule} from '@angular/material/select';
import {ScrollingModule } from '@angular/cdk/scrolling';
import {MatIconModule} from '@angular/material/icon';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { CustomInputModule } from '../custom-input/custom-input.module';
import { MatButtonModule } from '@angular/material/button';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';


@NgModule({
  declarations: [
    CustomDropDownListComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatSelectModule,
    ScrollingModule,
    MatIconModule,
    MatTooltipModule,
    CustomInputModule,
    MatButtonModule,
    NgxMatSelectSearchModule

  ],
  exports:[CustomDropDownListComponent],
  
})
export class CustomDropDownListModule { }
